import Footer3 from './Footer3'
export default Footer3
